import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { useMutation } from 'react-query'
import { useRollbar } from '@rollbar/react'
import {
  DownloadParams,
  postDownloadPdf,
} from '@dc-shared-web/hooks/api/document/postDownloadPdf'

export const usePostDownloadPdf = () => {
  const svcCrunchApiClient = useSvcCrunchesContext()
  const rollbar = useRollbar()

  return useMutation((mutationParams: DownloadParams) =>
    postDownloadPdf(svcCrunchApiClient, mutationParams, rollbar)
  )
}
